import React from "react";
import "./TagpayListComponent.css";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import leftArrow from "../../../../assests/leftArrow.svg";
import search from "../../../../assests/search.svg";
import emotions7 from "../../../../assests/emotions7.svg";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import LockIcon from "@mui/icons-material/Lock";
import { useNavigate } from "react-router-dom";
import LoadingSpinner from "../../../Loading/component";

const CorporateListComponent = (props) => {
  const navigate = useNavigate();

  const handleBackClick = () => navigate(-1);

  // Calculate totals

  return (
    <div className="corporate-list-container">
      <Sidebar />
      
      <div className="corporate-list-content">
        {props.loading ? (
          <LoadingSpinner />
        ) : (
          <>
            <div className="corporate-list-header">
              <button onClick={handleBackClick} className="back-button">
                <img src={leftArrow} alt="Back" />
              </button>
              <h1>Corporate List</h1>
            </div>

            <div className="corporate-list-controls">
              <div className="corporate-search-container">
                <div className="corporate-searchbar">
                  <input
                    type="search"
                    className="corporate-searchbar-input"
                    placeholder="Search Corporate By ID Or Name"
                    value={props.searchValue}
                    onChange={props.handleSearchInputChange}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        props.handleFilterCorporate();
                      }
                    }}
                  />
                  <button
                    className="corporate-searchbar-button"
                    onClick={props.handleFilterCorporate}
                    aria-label="Search"
                  >
                    <img src={search} alt="Search" />
                  </button>
                </div>
              </div>

              <Button
                variant="contained"
                className="create-corporate-button"
                onClick={props.handleCreateCorporate}
                startIcon={<AddIcon />}
              >
                Create New Corporate
              </Button>
            </div>

            <div className="corporate-table-container">
              <div className="table-scroll-wrapper" ref={props.tableContainerRef}>
                <table className="corporate-table">
                  <thead>
                    <tr>
                      <th>Corporate ID</th>
                      <th>Corporate Name</th>
                      <th>Total Users</th>
                      <th>Total Department</th>
                      <th>Total Rule</th>
                      <th>Total Tags</th>
                      <th>Configuration</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {props.filteredCorporateList?.length > 0 ? (
                      props.filteredCorporateList.map((corporate, index) => (
                        <tr key={corporate.corporateId || index}>
                          <td>{corporate.corporateId}</td>
                          <td>{corporate.corporateName}</td>
                          <td>{corporate.totalUsers || 0}</td>
                          <td>{corporate.totalDepartments || 0}</td>
                          <td>{corporate.totalRules || 0}</td>
                          <td>{corporate.totalTags || 0}</td>
                          <td>
                            <button 
                              className="config-button"
                              onClick={() => props.handleConfiguration(corporate.corporateId)}
                            >
                              {corporate.hasBPTag ? "BP Tag" : "+ BP Tag"}
                            </button>
                          </td>
                          <td>
                            <button 
                              className="action-button"
                              onClick={() => props.handleAction(corporate.corporateId)}
                            >
                              <LockIcon className="action-icon" />
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="8" className="no-results">
                          <div className="no-results-content">
                            <img src={emotions7} alt="No results" />
                            <p>No Corporate Found</p>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Summary Footer */}
            {/* {props.filteredCorporateList?.length > 0 && (
              <div className="corporate-summary-footer">
                <div className="summary-item">
                  <span className="summary-label">Total Users:</span>
                  <span className="summary-value">{totalUsers}</span>
                </div>
                <div className="summary-item">
                  <span className="summary-label">Total Department:</span>
                  <span className="summary-value">{totalDepartments}</span>
                </div>
                <div className="summary-item">
                  <span className="summary-label">Total Rule:</span>
                  <span className="summary-value">{totalRules}</span>
                </div>
                <div className="summary-item">
                  <span className="summary-label">Total Tags:</span>
                  <span className="summary-value">{totalTags}</span>
                </div>
              </div>
            )} */}

            {props.isLoadingMore && (
              <div className="loading-more">
                <LoadingSpinner />
                <p>Loading more...</p>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default CorporateListComponent;